angular.module('bmsApp.user')
	.controller('InstanceSelectionCtrl', [
		'$state',
		'$stateParams',
		'$scope',
		'AuthService',
		'SetupSvc',
		'$localStorage',
		'$http',
		function ($state,
				  $stateParams,
				  $scope,
				  AuthService,
				  SetupSvc,
				  $localStorage,
				  $http) {

			function init() {
				self.loading = true;
				if(angular.isDefined($localStorage.currentInstance)){
					AuthService.redirect();
				}
				AuthService.getUser().then(function(user){
					self.user = user;
					self.instances = self.user.franchise.instances;
					self.loading = false;
				});
			}

			function setInstance(instance) {
				$localStorage.currentInstance = instance;
				$http.defaults.headers.common = {'FranchiseInstanceId': instance.id};
				AuthService.redirect();
			}

			var self = $scope.InstanceSelectionCtrl = {
				methods: {
					init: init,
					setInstance: setInstance,
				},
			};

		}
	]);
